const TextField = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      gap: theme.spacing(1),
    }),
  },
};

export default TextField;
